import React from 'react';
import PropTypes from 'prop-types';
import Field from './Field';

import './TextField.scss';



export default function TextField({ style, label, value, placeholder, onChange, error, name }) {
  return (
    <Field
      style={style}
      className="form-text-field"
      label={label}
      value={value}
      error={error}
      
    >
      {(onFocus, onBlur, focus) => {
        return (
          <input
            type="text"
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={onFocus}
            onBlur={() => {
              onBlur(value);
            }}
            ref={(input) => {
              if (input && focus) {
                input.focus();
              }
            }}
          />
        );
      }}
    </Field>
  );
}

TextField.propTypes = {
  style: PropTypes.shape(),
  placeholder: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.node,
};

TextField.defaultProps = {
  style: {},
  placeholder: '',
  label: '',
  value: '',
  error: null,
};
